// Gera um identificador legivel pro plano a partir do nome (ex: "Plano
// Individual" -> "Individual"), pra usar em links de marketing no lugar
// do UUID. Usado tanto pra montar o link quanto pra encontrar de volta
// o plano correspondente a partir da URL.

export const getPlanSlug = (planName = '') => planName.replace('Plano ', '').trim();

export const findPlanBySlug = (plans = [], slug = '') => {
  if (!slug) return undefined;

  return plans.find(
    (plan) => getPlanSlug(plan.name).toLowerCase() === slug.toLowerCase(),
  );
};
